import { render, staticRenderFns } from "./notification.vue?vue&type=template&id=69ab5662&"
import script from "./notification.ts?vue&type=script&lang=ts&"
export * from "./notification.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports